import { withRouter } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';

import Tabs from 'components/CncUI/Tabs';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    '& .MuiTabs-indicator': {
      height: 4,
    },
    '& .MuiTabs-flexContainer': {
      borderBottomColor: 'transparent',
    },
  },
  tab: {
    color: palette.cncUI.primary.gray['+2'],
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '16px',
    borderBottomWidth: 4,
    '&:hover': {
      borderBottomWidth: 4,
    },
  },
}));

const TabMenu = props => {
  const classes = useStyles();
  const { menuData, location: { pathname } = {}, history } = props;

  const handleChange = (_, value) => history.push(value);

  // We have sub menus on some screens which means that the pathname isnt always the value
  // For our tab menu, but instead may be only part of the value.
  // For example when you click on admin, and then click on one of the sub menu items
  // The parent tab menu should keep admin dashboard selected
  // The reverse is so that we default to dashboard last, since it will always be true
  const { path: tabValue } =
    [...menuData]
      .reverse()
      .find(
        ({ path }) => pathname === path || pathname.startsWith(`${path}/`),
      ) || {};

  const renderTabs = () =>
    menuData.map(({ name, path, icon: IconComponent = null }) => (
      <Tabs.Item
        key={name}
        value={path}
        className={classes.tab}
        data-test-id={`TabMenu-tab-${path}`}
        icon={IconComponent ? <IconComponent /> : null}
      >
        {name}
      </Tabs.Item>
    ));

  return (
    <Tabs
      value={tabValue}
      data-test-id={`TabMenu-root`}
      onChange={handleChange}
      className={classes.root}
      variant="scrollable"
      scrollButtons="auto"
    >
      {renderTabs()}
    </Tabs>
  );
};

export default withRouter(TabMenu);
